import React, { useState } from "react";
import Modal from "../../../components/modal";
import { ReactSortable } from "react-sortablejs";
import { IoReorderTwoOutline } from "react-icons/io5";

export function ReorderListModal({ items, onReorder, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [list, setList] = useState(items);

  // Update list when items prop changes
  React.useEffect(() => {
    setList(items);
  }, [items]);

  const handleReorder = (newList) => {
    setList(newList);
  };

  const handleSave = () => {
    onReorder(list);
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setList(items); // Reset list to original items when closing without saving
  };

  return (
    <>
      {/* Always render the trigger button */}
      <div onClick={() => setIsOpen(true)} className="inline-block">
        {children}
      </div>

      {/* Render modal when open */}
      {isOpen && (
        <Modal isOpen={true} onClose={handleClose} className="max-w-xl w-full">
          <div className="p-6">
            <div className="flex flex-col">
              <h2 className="text-xl font-semibold mb-4">Reorder items</h2>
              <p className="text-sm text-gray-600 mb-4">Drag and drop items to reorder them in the list.</p>

              <div className="max-h-[60vh] overflow-y-auto mb-4">
                <ReactSortable
                  list={list}
                  setList={handleReorder}
                  animation={150}
                  ghostClass="opacity-50"
                  dragClass="z-50"
                  scroll={true}
                  scrollSensitivity={10}
                  forceFallback={true}>
                  {list.map((item, index) => (
                    <div
                      key={item.id || index}
                      className="flex items-center gap-2 px-2 py-1.5 bg-white border border-gray-200 rounded hover:border-blue-400 transition-colors group cursor-move">
                      <div className="hover:bg-blue-100 rounded">
                        <IoReorderTwoOutline className="w-4 h-4 text-gray-400 group-hover:text-blue-500" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-gray-900 text-sm group-hover:text-blue-600 font-medium truncate">{item.title || item.name || item}</div>
                        {item.description && <div className="text-xs text-gray-500 truncate">{item.description}</div>}
                      </div>
                    </div>
                  ))}
                </ReactSortable>
              </div>
            </div>
            <div className="flex justify-end gap-2">
              <button onClick={handleClose} className="px-3 py-1.5 text-sm font-medium text-gray-700 hover:text-gray-500">
                Cancel
              </button>
              <button onClick={handleSave} className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded">
                Save Order
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
